module.exports = require('./$.global');


/*****************
 ** WEBPACK FOOTER
 ** ./~/babel-polyfill/~/core-js/modules/$.path.js
 ** module id = 272
 ** module chunks = 0
 **/